export default __webpack_public_path__ + "static/media/health.4cfbe6d3.png";